import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useUpdateChangeSent = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, data.currentStatusName);

  return useApiMutation({
    url: `/orders/${orderId}/change-sent`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar pedido',
    successTitle: 'Pedido atualizado com sucesso',
    successMessage: 'A opção do troco foi atualizada!',
    onSuccess,
  });
};

export default useUpdateChangeSent;
